var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgexport5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.2 64.08",
    width: 64.2,
    height: 64.08,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "",
    "data-name": "Layer 2",
    fill: "#6F6F6F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "",
    "data-name": "Layer 1",
    fill: "#6F6F6F"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.5,61.5V64c-.28,0-.52,0-.76,0h-9C.39,64.08,0,63.7,0,62.39V53.31c0-.22,0-.44,0-.7H2.55V61.5Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.19,62.83a1.08,1.08,0,0,1-1,1.2c-3.47,0-7,0-10.47,0V61.53h8.92V52.62h2.49a1,1,0,0,1,.08.22C64.19,56.17,64.2,59.5,64.19,62.83Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.5,0V2.53H2.6v8.93H0c0-.25,0-.47,0-.68V1.69C0,.38.38,0,1.71,0h9C11,0,11.22,0,11.5,0Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.2,1.65v9.16c0,.2,0,.39,0,.65H61.65V2.56H52.71V0h9.81C63.8,0,64.19.39,64.2,1.65Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.1,52a20,20,0,1,1,20-20A20,20,0,0,1,32.1,52ZM32.1,14A18.07,18.07,0,1,0,50.17,32,18.1,18.1,0,0,0,32.1,14Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,53.25a2.86,2.86,0,0,1-1.2-.26,3,3,0,0,1-1.51-3.92h0a3,3,0,0,1,5.49.14,3,3,0,0,1-.05,2.28A3,3,0,0,1,19,53.25Zm-1-3.4h0a1.06,1.06,0,0,0,1.93.86,1,1,0,0,0,0-.81,1.06,1.06,0,0,0-.55-.59,1.08,1.08,0,0,0-.81,0A1,1,0,0,0,18.06,49.85Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.84,46.38a2.94,2.94,0,0,1-2.21-1,3,3,0,0,1,.22-4.2h0a3,3,0,1,1,4,4.42A2.93,2.93,0,0,1,12.84,46.38Zm-.71-3.76a1.06,1.06,0,0,0-.08,1.49,1.07,1.07,0,0,0,1.5.08,1.06,1.06,0,0,0-1.42-1.57Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,37.58a3,3,0,0,1-1.35-.32,3,3,0,0,1-1.3-4,2.94,2.94,0,0,1,1.73-1.48h0a3,3,0,0,1,1.84,5.66A2.89,2.89,0,0,1,10,37.58Zm0-4a1.26,1.26,0,0,0-.33.05h0a1.1,1.1,0,0,0-.61.53,1,1,0,0,0-.06.8,1,1,0,0,0,1.33.68,1,1,0,0,0,.61-.52,1.08,1.08,0,0,0,.07-.81,1,1,0,0,0-.53-.61A1,1,0,0,0,10,33.55Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,28.39l-.31,0a2.94,2.94,0,0,1-2-1.09A3,3,0,0,1,8,25.1a3,3,0,0,1,3.27-2.65h0a2.94,2.94,0,0,1,2,1.09,3,3,0,0,1-.44,4.18A2.92,2.92,0,0,1,11,28.39Zm0-4a1.08,1.08,0,0,0-.67.24,1,1,0,0,0-.38.71,1,1,0,0,0,.23.77,1,1,0,0,0,.71.39,1,1,0,0,0,.77-.23,1.06,1.06,0,0,0,.39-.71,1,1,0,0,0-.23-.77,1.06,1.06,0,0,0-.71-.39H11Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.57,20.38a3,3,0,1,1,1.49-5.56h0a3,3,0,0,1-1.49,5.56Zm0-4a1,1,0,0,0-.91.53,1.06,1.06,0,1,0,1.83,1.06,1.06,1.06,0,0,0-.39-1.44h0A1,1,0,0,0,15.57,16.34Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.06,14.94a3,3,0,1,1,2.4-4.72h0a3,3,0,0,1-.66,4.15A2.9,2.9,0,0,1,23.06,14.94Zm0-4a1,1,0,0,0-.62.2,1.06,1.06,0,0,0-.23,1.48,1.09,1.09,0,0,0,.69.42,1,1,0,0,0,.78-.19,1.06,1.06,0,0,0,.24-1.48h0A1.07,1.07,0,0,0,23.05,10.91Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.09,13a3,3,0,0,1-1.61-.48,3,3,0,0,1-.88-4.12,3,3,0,0,1,1.88-1.29A3,3,0,0,1,35,9.42h0A3,3,0,0,1,32.72,13,2.7,2.7,0,0,1,32.09,13Zm0-4a.82.82,0,0,0-.22,0,1.06,1.06,0,0,0-.36,1.92,1.12,1.12,0,0,0,.8.15,1.07,1.07,0,0,0,.81-1.26h0A1,1,0,0,0,32.1,9Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.15,14.94a3.18,3.18,0,0,1-.62-.06,3,3,0,1,1,2.24-.42A3,3,0,0,1,41.15,14.94Zm0-4a1.05,1.05,0,0,0-.89,1.63,1,1,0,0,0,.67.46,1.06,1.06,0,0,0,.79-.15,1,1,0,0,0,.46-.67,1.06,1.06,0,0,0-.82-1.25Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.62,20.38a3,3,0,1,1,3-3.44A3,3,0,0,1,51,19.15h0A3,3,0,0,1,48.62,20.38Zm0-4a1.08,1.08,0,0,0-.86.44A1.06,1.06,0,0,0,48,18.26,1.07,1.07,0,0,0,49.48,18a1.06,1.06,0,0,0-.85-1.68Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.26,28.39a3,3,0,0,1-.78-.11,2.93,2.93,0,0,1-1.81-1.38A3,3,0,1,1,54.74,28h0A3,3,0,0,1,53.26,28.39Zm0-4a1,1,0,0,0-.53.15A1.06,1.06,0,0,0,53,26.43a1,1,0,0,0,.8-.11h0a1,1,0,0,0,.49-.64,1.05,1.05,0,0,0-1-1.33Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.21,37.58a3,3,0,0,1-3-2.66,3,3,0,0,1,2.65-3.27,3,3,0,0,1,2.18.64,3,3,0,0,1,1.09,2,3,3,0,0,1-2.65,3.27Zm0-4h-.11a1,1,0,0,0-.71.38A1.06,1.06,0,1,0,55,35.27a1,1,0,0,0,.23-.77,1,1,0,0,0-.39-.71A1,1,0,0,0,54.22,33.55Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.36,46.38a3,3,0,0,1-2.83-3.9A3,3,0,0,1,54,42.05a3,3,0,0,1-1.3,4A2.9,2.9,0,0,1,51.36,46.38Zm0-4a1,1,0,0,0-.48.11,1,1,0,0,0-.52.62,1,1,0,0,0,.06.8,1.1,1.1,0,0,0,.61.53h0a1.08,1.08,0,0,0,.81-.07,1,1,0,0,0,.52-.61,1,1,0,0,0-.06-.81,1.08,1.08,0,0,0-.61-.52A1,1,0,0,0,51.36,42.35Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.17,53.25a3,3,0,1,1,2.21-1,2.94,2.94,0,0,1-2.05,1Zm0-4h-.05a1.06,1.06,0,0,0-.66,1.84h0A1.05,1.05,0,0,0,46,51a1.06,1.06,0,0,0,.27-.76,1.08,1.08,0,0,0-.35-.73A1.05,1.05,0,0,0,45.17,49.22Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.15,62.67a1,1,0,0,1-.95-.85L32.13,34.69,29.07,61.82a1,1,0,0,1-1.91-.22l4-35.56a1,1,0,0,1,1.91,0l4,35.56a1,1,0,0,1-.85,1.06Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.51,33.93h-33a1,1,0,0,1,0-1.92h33a1,1,0,0,1,0,1.92Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,33.8a1,1,0,0,1-1-1V16.45a1,1,0,0,1,1.92,0V32.84A1,1,0,0,1,32,33.8Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.67,45.61a1,1,0,0,1-.68-.28L19.63,22A1,1,0,0,1,21,20.61L44.35,44a1,1,0,0,1,0,1.36A.94.94,0,0,1,43.67,45.61Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.31,45.61a1,1,0,0,1-.68-.28,1,1,0,0,1,0-1.36L43,20.61A1,1,0,0,1,44.35,22L21,45.33A.94.94,0,0,1,20.31,45.61Z",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgexport5);
export default __webpack_public_path__ + "static/media/svgexport-5.2d7619bb636cfb0320bb2755a7b71177.svg";
export { ForwardRef as ReactComponent };